export interface RefNo {
    quoteReferenceNumber: string;
    formSessionId: string;
    quoteNumberFlag: number;
    editMode: boolean;
    applicationRefNumber?: string;
    isRefreshCard?: boolean;
    isValidated?: boolean;
}
